import { render, staticRenderFns } from "./h-tag.vue?vue&type=template&id=15c4cd69&"
import script from "./h-tag.vue?vue&type=script&lang=js&"
export * from "./h-tag.vue?vue&type=script&lang=js&"
import style0 from "./h-tag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports